export default __webpack_public_path__ + "static/media/left.9c205d4e.svg";